import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { Panel } from 'primeng/panel';
import { SearchFilter } from './search-filter.model';

@Component({
  selector: 'eo-search-panel',
  templateUrl: './eo-search-panel.component.html',
  styleUrl: './eo-search-panel.component.scss',
})
export class EoSearchPanelComponent {
  // @ViewChild('instructionDialog', { static: false })
  // instructionDialog?: InstructionsPanelComponent;

  @ViewChild('panel', { static: false })
  panelMenu?: Panel;

  @Input() filterConfig: any;
  @Input() isCollapsed = true;
  //@Input() viewModeVisible = true;

  private _viewModeVisible: boolean = true;
  @Input() set viewModeVisible(val: boolean) {
    this._viewModeVisible = val;
    this.menuActions = this.userMenuActions;
  }
  get viewModeVisible() {
    return this._viewModeVisible;
  }

  private _instructionsMenuItem?: MenuItem;
  @Input() set instructionsMenuItem(val: MenuItem | undefined) {
    this._instructionsMenuItem = val;
    this.menuActions = this.userMenuActions;
  }
  get instructionsMenuItem() {
    return this._instructionsMenuItem;
  }

  @Input() instructionsVisible = true;
  @Input() actionMenuVisible = true;
  @Input() formGroup?: FormGroup<any>;
  @Output() submit = new EventEmitter();
  @Output() viewModeChange = new EventEmitter<'TABLE' | 'GRID'>();

  private userMenuActions: MenuItem[] = [];
  private _menuActions: MenuItem[] = [];
  @Input() set menuActions(val: MenuItem[]) {
    this.userMenuActions = val;
    this._menuActions = [
      ...this.userMenuActions,
      ...this.getViewTableAction(),
      ...this.getViewGridAction(),
      ...this.getInstructionsAction(),
    ];
  }
  get menuActions() {
    return this._menuActions;
  }

  filters: SearchFilter[] = [];

  constructor() {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    //this.menuActions = [];
  }

  onRemoveFilter($event: SearchFilter): void {
    this.formGroup?.get($event.formControlName)?.reset();
    this.submit.emit();
  }

  getViewTableAction(): MenuItem[] {
    if (!this.viewModeVisible) return [];
    return [
      {
        id: '__VIEWMODE_TABLE',
        label: 'Προβολή σε πίνακα',
        icon: 'pi pi-list',
        visible: this.viewModeVisible,
        command: () => this.viewModeChange.emit('TABLE'),
      },
    ];
  }
  getViewGridAction(): MenuItem[] {
    if (!this.viewModeVisible) return [];
    return [
      {
        id: '__VIEWMODE_GRID',
        label: 'Προβολή σε κάρτες',
        icon: 'pi pi-table',
        visible: this.viewModeVisible,
        command: () => this.viewModeChange.emit('GRID'),
      },
    ];
  }
  getInstructionsAction(): MenuItem[] {
    if (!this.instructionsVisible || !this.instructionsMenuItem) return [];
    return [{ separator: true }, this.instructionsMenuItem];
  }

  setFilters(): void {
    let f: SearchFilter[] = [];

    if (!this.formGroup) return;

    Object.keys(this.formGroup.controls).forEach((k) => {
      const value = this.formGroup?.get(k)?.value;
      if (value) {
        f.push(
          new SearchFilter({
            formControlName: k,
            label: this.getFcLabel(k),
            value: value,
          })
        );
      }
    });

    this.filters = f;
  }

  getFcLabel(fcName: string): string {
    return (
      this.filterConfig?.find((c: any) => c?.formControlName === fcName)
        ?.label ?? ''
    );
  }

  hasFormControls(): boolean {
    if (!this.formGroup) return false;
    return Object.keys(this.formGroup.controls).length > 0;
  }

  isFilterButtonVisible(): boolean {
    return this.hasFormControls();
  }

  isActionMenuButtonVisible(): boolean {
    if (!this.actionMenuVisible) return false;
    if (this.menuActions?.length === 0) return false;
    if (this.menuActions?.find((m) => m.visible != false)) return true;
    return false;
  }
}
